export const getLabelSize = (size: string) =>
  size === "small" ? "paragraph2-100" : size === "medium" ? "paragraph1-100" : "medium100";
